<template>
  <div class="d-flex flex-column justify-center align-center"
  style="height: 100vh;">
    <span>404. Страница не найдена.</span>
    <router-link :to="{ name: 'home.index'}">На главную?</router-link>

  </div>
</template>

<script>
export default {
  name: '404',
};
</script>

<style scoped>

</style>
